import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import Logo from './Logo';
import { LogOut, LayoutDashboard, PlusCircle } from 'lucide-react';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10">
      <div className="container mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-16">
          <Link to="/" data-testid="nav-logo">
            <Logo />
          </Link>

          <div className="flex items-center gap-6">
            <Link to="/marketplace" data-testid="nav-marketplace">
              <Button variant="ghost" className="text-zinc-400 hover:text-white hover:bg-white/5">
                Marketplace
              </Button>
            </Link>

            {user ? (
              <>
                <Link to="/create-offer" data-testid="nav-create-offer">
                  <Button variant="ghost" className="text-zinc-400 hover:text-white hover:bg-white/5">
                    <PlusCircle className="w-4 h-4 mr-2" />
                    Vender Créditos
                  </Button>
                </Link>
                <Link to="/dashboard" data-testid="nav-dashboard">
                  <Button variant="ghost" className="text-zinc-400 hover:text-white hover:bg-white/5">
                    <LayoutDashboard className="w-4 h-4 mr-2" />
                    Dashboard
                  </Button>
                </Link>
                <Button
                  onClick={handleLogout}
                  variant="ghost"
                  className="text-zinc-400 hover:text-white hover:bg-white/5"
                  data-testid="nav-logout"
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  Sair
                </Button>
              </>
            ) : (
              <Link to="/auth" data-testid="nav-login">
                <Button className="bg-primary text-black hover:bg-[#B3E600] hover:shadow-[0_0_20px_rgba(204,255,0,0.3)] rounded-sm font-medium tracking-wide transition-all duration-200">
                  Entrar / Registrar
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
